import React, { useEffect, useRef, useState } from "react";
import { ReactJewishDatePicker } from "react-jewish-datepicker";
import "./HebrewDatePicker.scss";

const HebrewDatePicker = ({ title, name, date, ...props }) => {
  const hebrewDate = useRef(null);
  useEffect(() => {
    const element = hebrewDate.current.children[1].children[0].textContent;
    props.handleChange(element);
  }, []);
  return (
    <>
      <div className="customHebrewDate" ref={hebrewDate}>
        <label className="label-style">{title}</label>
        <ReactJewishDatePicker
          value={date ? new Date(date) : undefined}
          // isHebrew
          tite={title}
          name={name}
          className="hebrew-date-picker hebrew-date-of-dath"
          {...props}
        />
      </div>
    </>
  );
};

export default HebrewDatePicker;
